const Locations = {
  CITY: "city",
  DISTRICT: "district",
  TOWN: "town",
  LOCALITY: "locality",
  REGION: "region",
};
export default Locations;
